module.exports = __webpack_public_path__ + "img/feedback-success.89a47b83.png";